/** @jsx builderX.jsx */

import {builderX, Image, Sprite, Text} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite position={[0, 0]} name='cash'>
        <Image position={[0, 0]} mask={[50, 50, 1100, 150]} scale={[1, 2]} name='bg' src='bg_ui_wide_square'/>
        <Text
            position={[181, 112]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 160,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={800}
            name='fieldText'
            localeTextID=''
            text='$100.000'
        />
        <Text
            position={[179, 287]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 80,
                fontStyle: 'normal',
                fill: '#FFD200',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={800}
            name='label'
            localeTextID=''
            text='CASH'
        />
    </Sprite>
);
